import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "edit-profile" }
const _hoisted_3 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexEdit',
  setup(__props) {

const UserProfile = defineAsyncComponent(() => import("@/components/theme/user/edit/UserProfile.vue"))
const EditProfile = defineAsyncComponent(() => import("@/components/theme/user/edit/EditProfile.vue"))
const UserTable = defineAsyncComponent(() => import("@/components/theme/user/edit/UserTable.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Users",
      mains: "Edit Profile",
      title: "Edit Profile"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(UserProfile)),
          _createVNode(_unref(EditProfile)),
          _createVNode(_unref(UserTable))
        ])
      ])
    ])
  ], 64))
}
}

})